import { getCompactNumberFormat, getNumberFormat } from './locale';

export const localizeNumber = (value: number, locale?: string) =>
  getNumberFormat(locale).format(value);

export const localizeCompactNumber = (
  value: number,
  locale?: string,
  options?: Intl.NumberFormatOptions,
) => getCompactNumberFormat(locale, options).format(value);
